/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowCircleDown(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm39.59375,115.71875L133.666,173.64648a8.02367,8.02367,0,0,1-11.332,0L88.40625,139.71875a7.99915,7.99915,0,0,1,11.3125-11.3125L120,148.6875V88a8,8,0,0,1,16,0v60.6875l20.28125-20.28125a7.99915,7.99915,0,0,1,11.3125,11.3125Z" />
    </Svg>
  );
}

export default ArrowCircleDown;
